import styles from "./Sidebar.module.scss";
import logoIcon from "../../assets/images/logo.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MenuItem, sidebarMenuItems } from "./sidebarMenuItems";

const Sidebar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const clickOnLogo = () => {
    navigate("/");
  };

  return (
    <div className={styles.container}>
      <img onClick={clickOnLogo} className={styles.logo} src={logoIcon} alt={"logo"} />

      <nav className={styles.nav}>
        <ul className={styles.menu}>
          {sidebarMenuItems.map((item: MenuItem) => {
            return (
              <li className={styles.item} key={item.to}>
                <NavLink
                  className={({ isActive }) =>
                    isActive ? `${styles.link} ${styles.active}` : styles.link
                  }
                  to={item.to}
                >
                  <span dangerouslySetInnerHTML={{ __html: item.icon }}></span>
                  {t(item.labelKey)}
                </NavLink>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
